import apiClient from "../utils/apiClient";

export const getAllHubAppProfiles = async () => {
    const response = await apiClient.get("/hub-app-profiles");
    return response.data?.appProfiles || [];
};

